import { ICefSharpWeighingMachine } from "./Interfaces/ICefSharpWeighingMachine";

import { ICefSharp } from "./Interfaces/_ICefSharp";

declare const CefSharp: ICefSharp;
declare const weighingScaleService: ICefSharpWeighingMachine;

export const CefSharpWeighingMachine = (): ICefSharpWeighingMachine => {
  const getValueFromWighingScale = async (port: string) => {
    await CefSharp.BindObjectAsync("weighingScaleService");
    await weighingScaleService?.getValueFromWighingScale(port);
  };

  return { getValueFromWighingScale };
};
